'use es6';

// TODO: Convert to TypeScript and DataFetchingClient
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UIFlex from 'UIComponents/layout/UIFlex';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { setUserGuideSettingsAndReturnUrl } from '../../actions/GettingStartedActions';
import { getRecommendationsTopicPreference } from '../../selectors/recommendationsSelectors';
import ModalVideoSection from './ModalVideoSection';
import ModalPricingSection from './ModalPricingSection';
import blobsUrl from 'bender-url!../../../images/blob-modal-header.svg';
import UIImage from 'UIComponents/image/UIImage';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { getAcademyToSoftwareModalTriggerSource } from '../../selectors/academyToSoftwareSelectors';
import { showTooltip } from '../../actions/AcademyToSoftware';
import UsageTracker from '../../utils/UsageTracker';
import { HotjarTrigger } from 'LearningCenterUI/components/Hotjar';
import { fetchAccounts } from '../../actions/AccountsActions';
import { requestProducts } from '../../actions/ProductsActions';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { useRouteMatch } from 'react-router-dom';
import { UserAttributeKeys, useUserAttribute } from '../../features/userAttributes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubHeading = styled.p.withConfig({
  displayName: "SoftwareDesirabilityModal__SubHeading",
  componentId: "sc-3asosx-0"
})(["margin:0 auto 30px;@media (max-width:", "){padding:0 16px;text-align:center;}"], GRID_BREAKPOINT_SMALL);
const BlobWrapper = styled.div.withConfig({
  displayName: "SoftwareDesirabilityModal__BlobWrapper",
  componentId: "sc-3asosx-1"
})(["padding-left:40px;padding-right:40px;margin-left:40px;margin-right:40px;margin-bottom:30px;border-top:1px solid ", ";display:block;@media (max-width:", "){display:none;}"], GREAT_WHITE, GRID_BREAKPOINT_SMALL);
const TabButtonContainer = styled(UIFlex).withConfig({
  displayName: "SoftwareDesirabilityModal__TabButtonContainer",
  componentId: "sc-3asosx-2"
})(["padding-left:40px;padding-right:40px;@media (max-width:", "){padding-left:16px;padding-right:16px;flex-direction:column;}"], GRID_BREAKPOINT_SMALL);
export const SmallUISelectableButton = styled(UISelectableButton).withConfig({
  displayName: "SoftwareDesirabilityModal__SmallUISelectableButton",
  componentId: "sc-3asosx-3"
})(["&& > div{min-height:40px !important;}@media (max-width:", "){max-width:unset !important;}"], GRID_BREAKPOINT_SMALL);
const topicToHub = {
  marketing: 'marketing',
  sales: 'sales',
  'services-support': 'service',
  service: 'service'
};
const hubs = ['marketing', 'sales', 'service'];
const SoftwareDesirabilityModal = ({
  onClose,
  topicPreference,
  modalTriggerSource,
  showTooltipAfterClose,
  getAccounts,
  getProducts,
  accountsNotFetched,
  productsNotFetched
}) => {
  const hubPreference = hubs.includes(topicToHub[topicPreference]) ? topicToHub[topicPreference] : 'marketing';
  const [selectedHub, setSelectedHub] = useState(hubPreference);
  const {
    path
  } = useRouteMatch();
  const isWizardOpen = path === '/wizard';
  const {
    userAttribute: hasSeenCloseTooltipAttribute
  } = useUserAttribute(UserAttributeKeys.HAS_SEEN_CLOSE_TOOLTIP);
  useEffect(() => {
    if (accountsNotFetched) {
      getAccounts();
    }
    if (productsNotFetched) {
      getProducts();
    }
  }, [accountsNotFetched, getAccounts, getProducts, productsNotFetched]);
  useEffect(() => {
    setSelectedHub(hubPreference);
  }, [hubPreference]);
  useEffect(() => {
    UsageTracker.track('interaction', {
      action: 'academy-to-software-modal-viewed',
      hubPreference,
      topicPreference
    });
  }, [hubPreference, topicPreference]);
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-selected-software": selectedHub,
    "data-test-id": "academy-to-software-desirability-modal",
    use: "conversational",
    width: 1234,
    children: [/*#__PURE__*/_jsx(HotjarTrigger, {
      name: "academy-to-software-modal-view"
    }), /*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.softwareDesirability.modal.title`
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => {
          onClose();
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-close-clicked'
          });
          if (modalTriggerSource === 'INFO_BUTTON' && !hasSeenCloseTooltipAttribute && !isWizardOpen) {
            showTooltipAfterClose();
          }
        }
      })]
    }), /*#__PURE__*/_jsx(SubHeading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.softwareDesirability.modal.subHeading`
      })
    }), /*#__PURE__*/_jsx(BlobWrapper, {
      children: /*#__PURE__*/_jsx(UIImage, {
        src: blobsUrl
      })
    }), /*#__PURE__*/_jsx(TabButtonContainer, {
      justify: "center",
      children: hubs.map(hub => /*#__PURE__*/_jsx(SmallUISelectableButton, {
        className: "tab-button",
        "data-test-id": `software-desirability-modal-tab-${hub}`,
        onSelectedChange: () => {
          UsageTracker.track('interaction', {
            action: 'academy-to-software-modal-hub-tab-changed',
            hubPreference,
            topicPreference,
            previousHub: selectedHub,
            newHub: hub
          });
          setSelectedHub(hub);
        },
        selected: selectedHub === hub,
        textLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.softwareDesirability.modal.hubs.${hub}.name`
        })
      }, hub))
    }), /*#__PURE__*/_jsx(ModalVideoSection, {
      hub: selectedHub,
      onCTAClick: onClose
    }), /*#__PURE__*/_jsx(ModalPricingSection, {
      hub: selectedHub,
      onCTAClick: onClose,
      priceLoading: productsNotFetched
    })]
  });
};
const mapStateToProps = state => {
  const topicPreference = getRecommendationsTopicPreference(state);
  return {
    topicPreference: state.academyToSoftware.selectedSoftware || topicPreference && topicPreference.get('topic') || 'other',
    modalTriggerSource: getAcademyToSoftwareModalTriggerSource(state),
    userId: state.auth.user.user_id,
    accountsNotFetched: state.accounts.get('data') === null && !state.accounts.get('isRequesting') && !state.accounts.get('hasError'),
    productsNotFetched: state.products.get('data') === null && !state.products.get('isRequesting') && !state.products.get('hasError')
  };
};
const mapDispatchToProps = {
  setOnboardingSettings: setUserGuideSettingsAndReturnUrl,
  showTooltipAfterClose: showTooltip,
  getAccounts: fetchAccounts,
  getProducts: requestProducts
};
export default connect(mapStateToProps, mapDispatchToProps)(SoftwareDesirabilityModal);